import { ReportUtils } from './report.utils';
import { SessionProvider } from '../providers/session.provider';

export enum TabName {
  DASHBOARD = 'dashboard',
  REGISTER = 'register',
  REPORTS = 'reports',
}

export enum TabNumber {
  DASHBOARD = 0,
  REGISTER = 1,
  REPORTS = 2,
}

export class RefersUtils {

  static getTabNameByIndex(index: number): string {
    let name = '';
    switch (index) {
      case 1:
        name = TabName.REGISTER;
        break;
      case 2:
        name = TabName.REPORTS;
        break;
      default:
        name = TabName.DASHBOARD;
    }
    return name;
  }

  static getTabIndexByName(name: string): number {
    let index = 0;
    switch (name) {
      case TabName.REGISTER:
        index = TabNumber.REGISTER;
        break;
      case TabName.REPORTS:
        index = TabNumber.REPORTS;
        break;
      default:
        index = TabNumber.DASHBOARD;
    }
    return index;
  }

  static reviewDate(date) {
    if (date.length === 0) {
      return 'No disponible';
    } else if (date.substring(0, 3).includes('/') || date.substring(0, 3).includes('-')) {
      return ReportUtils.fixDateFormat(date);
    } else {
      return ReportUtils.fixDateFormat(date, 2);
    }
  }

  static getNavLinks() {
    const session = new SessionProvider();
    let navLinks = [];
    let allRefersTabEnabled = true;
    const rolesList: any [] = session.getUserRoles();

    rolesList.forEach((item, index) => {
      if (item.CN === 'MCA-CSR') {
        allRefersTabEnabled = false;
      }
    });

    if (allRefersTabEnabled) {
      navLinks = NavLinks;
    } else {
      navLinks = [NavLinks[1]];
    }
    return navLinks;
  }

  static redirectReferRoute(): string {
    const session = new SessionProvider();
    let allRefersTabEnabled = true;
    const rolesList: any [] = session.getUserRoles();

    rolesList.forEach((item, index) => {
      if (item.CN === 'MCA-CSR') {
        allRefersTabEnabled = false;
      }
    });

    if (allRefersTabEnabled) {
      return '/refers/dashboard';
    } else {
      return '/refers/register';
    }
  }
}

const NavLinks = [
  {
    label: 'Dashboard',
    link: TabName.DASHBOARD,
    index: 0
  },
  {
    label: 'Registrar Código',
    link: TabName.REGISTER,
    index: 1
  },
  {
    label: 'Reportes',
    link: TabName.REPORTS,
    index: 2
  },
];
